export class TableSignal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "TableSignalKind",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "since",
            "baseName": "since",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "until",
            "baseName": "until",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "baseline",
            "baseName": "baseline",
            "type": "number",
            "format": ""
        },
        {
            "name": "observed",
            "baseName": "observed",
            "type": "number",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableSignal.attributeTypeMap;
    }
    constructor() {
    }
}
